// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 378 ? "user" : chunkId) + "." + {"186":"0a683900","378":"d27c8c06","485":"4eac7f54"}[chunkId] + ".css";
};